<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Routes</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row">
            <!-- <div class="mr-2">
              <bulk-upload-vehicle />
            </div> -->
            <div class="mr-2">
              <new-route @created="handleCreated"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row align-items-center">
          <div class="col-12 col-md-6 mb-2" v-if="!selectedRowKeys.length">
            <a-input-search
              placeholder="Search Routes..."
              size="large"
              v-model="search"
              @search="searchRoutes"
            />
          </div>

        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <route-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import RouteTable from '@/components/transport/route/index'
import NewRoute from '@/components/transport/route/new'
// import BulkUploadVehicle from '@/components/transport/vehicle/bulk/index'

import { debounce } from 'lodash'

export default {
  components: {
    RouteTable,
    NewRoute,
    // BulkUploadVehicle,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('inventory', 22)
    rc.then(data => {
      // console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  created() {
    this.searchRoutes = debounce(this.searchRoutes, 500)
  },
  mounted: function() {
    this.getRoutes()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      search: null,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getRoutes: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true
      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }
      this.$http.get('/api/transport/route', {
        params: {
          limit: this.pageSize,
          page: page,
          search: this.search,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchRoutes: function(value) {
      this.search = value
      this.getRoutes(true)
    },
    handleCreated: function() {
      this.getRoutes()
    },
    handleUpdateTable: function() {
      this.getRoutes()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getRoutes()
    },
    onChange(current) {
      this.current = current
      this.getRoutes()
    },
    handleClassSelect(selectedClassId) {
      this.getRoutes(true)
    },
    handleCategorySelect(selectedCategoryId) {
      this.getRoutes(true)
      this.getSubCategories(selectedCategoryId)
    },
    handleSubCategorySelect(selectedSubCategoryId) {
      this.getRoutes(true)
    },
  },
}
</script>
  <style>
  .error { padding: 25px 5px; }
  </style>
